import React, {useContext} from 'react'
import { appContext } from './Context/appProvider';
import Header from './Components/Header/Header'
import Sidebar from './Components/Sidebar/Sidebar'
import Notification from './Components/Notification/Notification';
// import Status from './Components/Status/Status'

export default function Layout({ children }) {
  const { token, notification, setNotification } = useContext(appContext)

  return (
    <div className="bg-[#e7e7e7] h-full flex flex-col w-full">
      {notification.visible && <Notification setNotification={setNotification} type={notification.type} message={notification.message} /> }
      <Header />
      <div className='flex-1 flex mt-3 overflow-auto'>
        <Sidebar />
        <div className='flex w-full flex-col gap-3 px-4 max-md:ml-0'>
            {children}
        </div>
      </div>
    </div>
  )
}
